#import "../../../../core/email-marketing/graphql/fragments/em-from-address-fragment.graphql"

fragment SharedInboxAddressFragment on SharedEmailInboxConfig {
    nutshellAddress {
        email {
            address
        }
    }
    sharedAddresses {
        ...FromAddress
        forwardingVerifiedTime
    }
}
